// extracted by mini-css-extract-plugin
export default {"container":"qQ-z","title":"rQ-z","link":"sQ-z"};